var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sdz-modal",
    {
      ref: "sdzModal",
      attrs: {
        title: _vm.modalTitle,
        "disabled-confirm": _vm.isDisabled,
        "confirm-button-label": "Salvar",
        "confirmation-event": "saveConfiguration",
        "cancel-event": "cancelConfiguration",
        width: "600",
        persistent: "",
        "custom-class": "default-sheet-modal",
        "buttons-position": "right",
        "close-icon": "",
      },
      on: {
        close: _vm.close,
        saveConfiguration: _vm.saveConfiguration,
        cancelConfiguration: _vm.cancelConfiguration,
      },
    },
    [
      [
        _c(
          "div",
          { staticClass: "content" },
          [
            _vm.loading
              ? _c("AppLoadingIcon", {
                  staticClass: "loading",
                  attrs: { color: "#BBB" },
                })
              : [
                  _c("div", { staticClass: "list-header" }, [
                    _c("span", { staticClass: "col-accelerator" }, [
                      _c("h3", [_vm._v("Acelerador")]),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "col-items" }, [
                      _c("h3", [_vm._v("Itens")]),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "col-sdz-prize" }, [
                      _c("h3", [_vm._v("Prêmio")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item-list" },
                    _vm._l(_vm.accelerators, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "list-item" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-accelerator v-label theme--light",
                              class: { "text-disabled": _vm.isDisabled },
                            },
                            [
                              _c("AppCheckBox", {
                                attrs: {
                                  disabled: _vm.isDisabled,
                                  options: [{ title: item.name, value: true }],
                                },
                                model: {
                                  value: item.checked,
                                  callback: function ($$v) {
                                    _vm.$set(item, "checked", $$v)
                                  },
                                  expression: "item.checked",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-items v-label theme--light",
                              class: { "text-disabled": _vm.isDisabled },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.getItens(item)) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-sdz-prize v-label theme--light",
                              class: { "text-disabled": _vm.isDisabled },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.seedzPrize) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
          ],
          2
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }